import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createFeature,
  getAFeature,
  resetState,
  updateAFeature,
} from "../features/feature/featureSlice";

let schema = yup.object().shape({
  title: yup.string().required("Feature Name is Required"),
});
const AddFeature = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getFeatureId = location.pathname.split("/")[3];
  const newFeature = useSelector((state) => state.feature);
  const {
    isSuccess,
    isError,
    isLoading,
    createdFeature,
    featureName,
    updatedFeature,
  } = newFeature;
  useEffect(() => {
    if (getFeatureId !== undefined) {
      dispatch(getAFeature(getFeatureId));
    } else {
      dispatch(resetState());
    }
  }, [getFeatureId]);

  useEffect(() => {
    if (isSuccess && createdFeature) {
      toast.success("Feature Added Successfully!");
    }
    if (isSuccess && updatedFeature) {
      toast.success("Feature Updated Successfully!");
      navigate("/admin/feature-list");
    }

    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: featureName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getFeatureId !== undefined) {
        const data = { id: getFeatureId, featureData: values };
        dispatch(updateAFeature(data));
        dispatch(resetState());
      } else {
        dispatch(createFeature(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 1000);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getFeatureId !== undefined ? "Edit" : "Add"} Feature
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
            label="Enter Feature"
            id="feature"
          />
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getFeatureId !== undefined ? "Edit" : "Add"} Feature
          </button>
        </form>
      </div>
    </div>

  );
};

export default AddFeature;
